export default "<app-client [id]=\"id\">\r\n</app-client>\r\n"